import "./App.css";
import Streams from "./components/Streams";
import Top from "./components/Top";
import Error from "./components/Error";
import { HashRouter, Route, Routes } from "react-router-dom";

function App() {
  return (
    <HashRouter>
      <Routes>
        <Route exact path={`/`} element={<Top />} />
        <Route path={`/streams/:id1/:id2/:id3/:id4`} element={<Streams />} />
        <Route path={`/streams/:id1/:id2/:id3`} element={<Streams />} />
        <Route path={`/streams/:id1/:id2`} element={<Streams />} />
        <Route path={`/streams/:id1`} element={<Streams />} />
        <Route path={`/streams/`} element={<Streams />} />
        <Route path={"*"} element={<Error />} />
      </Routes>
    </HashRouter>
  );
}

export default App;
